export default __webpack_public_path__ + "static/media/888-logo.43c8e659.svg";